<template>
  <v-container>
    <h1 class="text-h5 font-weight-bold mb-4">MRR Daily</h1>
    <mrr-daily-panel />
  </v-container>
</template>

<script>
import MrrDailyPanel from '../components/MrrDailyPanel.vue';

export default {
  name: 'MrrDaily',
  components: { MrrDailyPanel },
};
</script>
